import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/src/app/page.module.scss");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/src/components/navbar/index.module.scss");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/src/components/footer/index.module.scss");
